import { ActionableContainer, Skeleton, TextSkeleton } from '@gitbook/spine-react';

export function AdaptiveContentSiteSchemaEditorSkeleton() {
    return (
        <div className="flex max-h-[70vh]">
            <ActionableContainer className="shrink-0 grow-0 basis-1/2 px-10 py-6">
                <TextSkeleton>
                    <span>Step 1: Create visitor schema</span>
                </TextSkeleton>
                <div className="mt-2 space-y-2">
                    <TextSkeleton>
                        To adapt content to your visitors, you need to pass along data about them.
                    </TextSkeleton>
                    <TextSkeleton>
                        The visitor schema defines what data you will send over, ...
                    </TextSkeleton>
                    <TextSkeleton>
                        The JSON schema below should match the structure of the data...
                    </TextSkeleton>
                    <TextSkeleton>
                        Use the code samples on the right to start sending data.
                    </TextSkeleton>
                </div>
                <Skeleton shape="rect" className="mt-4 h-[300px] w-full">
                    JSON Schema Field
                </Skeleton>
            </ActionableContainer>

            <ActionableContainer className="shrink-0 grow-0 basis-1/2 bg-side py-6">
                <div className="flex flex-col gap-2 px-10">
                    <TextSkeleton>
                        <span>Step 2: Pass data to your docs</span>
                    </TextSkeleton>
                    <div className="mt-2 space-y-2">
                        <TextSkeleton>
                            There are different ways to pass visitor data to adapt your site's
                            content.
                        </TextSkeleton>
                        <TextSkeleton>
                            Your site will automatically monitor all of these methods for data.
                        </TextSkeleton>
                        <TextSkeleton>You don’t have to enable anything.</TextSkeleton>
                    </div>
                    <Skeleton shape="rect" className="mt-4 h-[300px] w-full">
                        Code Samples Section
                    </Skeleton>
                </div>
            </ActionableContainer>
        </div>
    );
}
